export type ProjectCategory = 'web' | 'backend' | 'automation' | 'tools';

export interface Project {
  id: string;
  title: string;
  category: ProjectCategory;
  label: string;
  description: string;
  technologies: string[];
  challenge: string;
  outcome: string;
  icon: string;
  liveUrl?: string;
}

export const projects: Project[] = [
  {
    id: 'syncronize-release',
    title: 'Syncronize Release',
    category: 'web',
    label: 'Agendamentos para formaturas',
    description: 'Uma agenda feita para a rotina de empresas de formaturas e eventos.',
    technologies: ['Java', 'Spring', 'Spring Boot'],
    challenge: 'Organizar sessões e compromissos respeitando as regras de cada evento.',
    outcome: 'Um sistema de agendamentos com os fluxos específicos do segmento de formaturas.',
    icon: 'fa-calendar-check',
    liveUrl: 'https://syncronize.squareweb.app/'
  },
  {
    id: 'migracao-sge',
    title: 'Migração SGE',
    category: 'backend',
    label: 'Dados e integração',
    description: 'Dados da Studio Formaturas preparados para a mudança de sistema para o SGE.',
    technologies: ['Python', 'MySQL', 'Migração de dados'],
    challenge: 'Levar os dados do sistema antigo para o SGE sem interromper a operação.',
    outcome: 'Dados tratados e validados para dar continuidade ao trabalho no novo sistema.',
    icon: 'fa-database',
    liveUrl: 'https://sistema.sge.com.br/'
  },
  {
    id: 'discord-bot',
    title: 'Bot para Discord',
    category: 'automation',
    label: 'Automação de comunidades',
    description: 'Anúncios de lives da Twitch, rádio KCRW e acompanhamento de atividades dentro do Discord.',
    technologies: ['TypeScript', 'Discord.js', 'Twitch API'],
    challenge: 'Reunir anúncios e transmissões que antes dependiam de ações manuais.',
    outcome: 'Publicações automáticas e comandos para cuidar da comunidade pelo próprio Discord.',
    icon: 'fa-robot'
  },
  {
    id: 'relatorios-sge',
    title: 'Relatórios SGE',
    category: 'tools',
    label: 'Indicadores comerciais',
    description: 'Uma aplicação desktop que transforma dados do SGE em relatórios de vendas.',
    technologies: ['Electron', 'React', 'API SGE', 'Chart.js'],
    challenge: 'Consultar comissões e ticket médio sem refazer os cálculos em planilhas.',
    outcome: 'Relatórios com cálculo de comissões, ticket médio e acompanhamento de vendas.',
    icon: 'fa-chart-simple'
  }
];
